import React, { useEffect, useRef, useState } from "react";
import "../Styles/HairSection.css";

function HairMakeOver() {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          obs.unobserve(el);
        }
      },
      { threshold: 0.2 }
    );

    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  
  // Hair Make Over
  const makeoverBlocks = [
    {
      title: "Straightening",
      desc: "If you love poker straight tresses, this one is for you.",
      items: ["Re-growth", "Upto neck", "Upto shoulder", "Upto mid back", "Waists & below"],
    },
    {
      title: "Smoothening",
      desc: "Reduces frizz and enhances shine, making hair smoother and more manageable.",
      items: ["Upto neck", "Upto shoulder", "Upto mid back", "Waists & below"],
    },
  ];

  // Hair Colouring
  const colouringBlocks = [
    [
      {
        title: "ROOT TOUCH-UP",
        items: [
          "L'oreal (Majirel) Schwarzkopf (igora royal)",
          "L'oreal (inoa) Schwarzkopf (Essensity)",
        ],
      },
      {
        title: "GLOBAL COLOURING",
        items: [
          "L'oreal (Majirel) Schwarzkopf (igora royal)",
          "Shoulder Length",
          "Mid back Length",
          "Waist Length",
        ],
      },
    ],
    [
      {
        title: "GLOBAL COLOURING",
        items: [
          "L'oreal (inoa) Schwarzkopf (Essential)",
          "Shoulder Length",
          "Mid back Length",
          "Waist Length",
        ],
      },
      {
        title: "HIGHLIGHTS COLOURING",
        items: ["Per Streak", "Stripping", "Full Global Highlights"],
      },
    ],
  ];

  // WhatsApp
  const handleBookAppointment = () => {
    const phoneNumber = "919912232487";
    const message = encodeURIComponent("Hello! I’d like to book an appointment.");
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
  };

  return (
    <section ref={sectionRef} className={`hair-section ${isVisible ? "fade-in" : ""}`}>
      
      {/* Hair Make Over */}
      <div id="hair-makeover" className="hair-block">
        <h2 className={`hair-title ${isVisible ? "show" : ""}`}>Hair Make Over</h2>
        <div className="hair-inner-columns">
          {makeoverBlocks.map((blk) => (
            <div className="spa-block" key={blk.title}>
              <h3 className={`spa-subtitle ${isVisible ? "show" : ""}`}>{blk.title}</h3>
              <p className="hair-desc">{blk.desc}</p>
              <ul className="hair-list">
                {blk.items.map((it, ii) => (
                  <li key={ii} className={`hair-item ${isVisible ? "show" : ""}`}>
                    {it}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Hair Colouring */}
      <div id="hair-colouring" className="hair-block">
        <h3 className={`hair-title ${isVisible ? "show" : ""}`}>Hair Colouring</h3>
        {colouringBlocks.map((col, ci) => (
          <div key={ci} className="hair-inner-columns">
            {col.map((blk) => (
              <div className="spa-block" key={blk.title}>
                <h3 className={`spa-subtitle ${isVisible ? "show" : ""}`}>{blk.title}</h3>
                <ul className="hair-list">
                  {blk.items.map((it, ii) => (
                    <li key={ii} className={`hair-item ${isVisible ? "show" : ""}`}>
                      {it}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* Book Appointment */}
      <div className="text-center" style={{ marginTop: "2rem" }}>
        <button onClick={handleBookAppointment} className="book-btn">
          📅 BOOK APPOINTMENT
        </button>
      </div>
    </section>
  );
}

export default HairMakeOver;
